import { Checkbox } from '@toolbox/components';
import { useField } from '@toolbox/form';

import type { CheckboxProps } from '@toolbox/components';
import type { FieldPath, FieldValues, UseFieldProps } from '@toolbox/form';
import type { RequiredBy } from '@toolbox/utils';

export type CheckboxFieldProps<
  FD extends FieldValues = FieldValues,
  Name extends FieldPath<FD> = FieldPath<FD>,
> = UseFieldProps<FD, Name> & RequiredBy<Omit<CheckboxProps, 'value'>, 'name'>;

export function CheckboxField<
  FD extends FieldValues = FieldValues,
  Name extends FieldPath<FD> = FieldPath<FD>,
>({ required, rules, error, ...props }: CheckboxFieldProps<FD, Name>): JSX.Element {
  const defaultErrorMessage = 'Dieses Feld ist erforderlich';
  const {
    fieldState,
    field: { ref, ...field },
  } = useField({
    name: props.name,
    rules: {
      required,
      ...rules,
    },
  });

  return (
    <Checkbox
      {...props}
      {...field}
      error={
        fieldState.error?.message || fieldState.invalid ? error || defaultErrorMessage : undefined
      }
    />
  );
}
